import { render, staticRenderFns } from "./capt_zhao_vsl_account.vue?vue&type=template&id=ab2f8d08"
import script from "./capt_zhao_vsl_account.vue?vue&type=script&lang=js"
export * from "./capt_zhao_vsl_account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports